import { useCallback, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLoginStore } from '../../../store/useLogin';

/**
 * @author taulmax
 * @create 2024.10.07
 * @update 2024.10.21
 * @description 로고 컴포넌트
 */
const Logo = () => {
  const { role } = useLoginStore();

  const ROLE_LOGO_TEXT = useMemo(
    () => ({
      ROLE_USER: 'Fortune LAB 가맹점',
      ROLE_ADMIN: 'Fortune LAB 관리자',
      ROLE_CS: 'Fortune LAB 씨에스',
      ROLE_TRACKING: 'Fortune LAB 트래킹',
      ROLE_JOINED: 'Fortune LAB 가입대기중',
      ROLE_MARKETING: 'Fortune LAB 마케팅',
    }),
    []
  );

  const ROLE_LOGO_CLICK_URL = useMemo(
    () => ({
      ROLE_USER: '/today-saju/codes',
      ROLE_ADMIN: '/order/fix',
      ROLE_CS: '/order/create',
      ROLE_TRACKING: '/today-saju/codes',
      ROLE_JOINED: '/',
      ROLE_MARKETING: '/today-saju/codes',
    }),
    []
  );

  const navigate = useNavigate();
  const onClickLogo = useCallback(() => {
    navigate(ROLE_LOGO_CLICK_URL[role]);
  }, [ROLE_LOGO_CLICK_URL, navigate, role]);

  return (
    <div 
      onClick={onClickLogo} 
      className="!h-[70px] !flex !items-center !justify-center !cursor-pointer !border-b !border-gray-700 hover:!bg-gray-800 !transition-colors"
    >
      <style>{`
        @font-face {
          font-family: 'SSRockRegular';
          src: url('/font/SSRockRegular.ttf') format('truetype');
          font-weight: normal;
          font-style: normal;
        }
      `}</style>
      <h1 
        className="!font-bold !text-white !text-center !tracking-wide !text-2xl"
        style={{ fontFamily: 'SSRockRegular' }}
      >
        {ROLE_LOGO_TEXT[role]}
      </h1>
    </div>
  );
};

export default Logo;
